@if ((currentCustomProvisioningData$ | async) === undefined) {
  <section class="breadcrumb-section">
    <ra-ui-breadcrumb
      id="ra-ui-portal-breadcrumb"
      [items]="(breadcrumbs$ | async) || []"
      [config]="breadcrumbConfig"
      (onClick)="onClicked($event)"
      [title]="(title$ | async) || ''"
    >
    </ra-ui-breadcrumb>

    <ng-template #iconTemplate>
      <i class="navigation-separator-style ra-icon-ide-sm-caret-right"></i>
    </ng-template>
  </section>
}

@if (navigateSignal$ | async) {}
